import { createContext, useContext, useMemo } from 'react';

import { useGetHotelChain } from '@spazious/react-booking-engine';

export const AppHotelChainDataContext = createContext<ReturnType<typeof useGetHotelChain> | null>(
  null
);

export type AppHotelChainDataProviderProps = {
  hotelChainSlug?: string;
  children?: React.ReactNode;
};

export const AppHotelChainDataProvider: React.FC<AppHotelChainDataProviderProps> = ({
  hotelChainSlug,
  children,
}) => {
  const hotelChainQueryResult = useGetHotelChain({
    variables: { slug: hotelChainSlug! },
    skip: hotelChainSlug === 'localhost' || !hotelChainSlug,
    refetchOnWindowFocus: false,
  });

  const value = useMemo(() => hotelChainQueryResult, [hotelChainQueryResult]);
  return (
    <AppHotelChainDataContext.Provider value={value}>{children}</AppHotelChainDataContext.Provider>
  );
};

/**
 *
 * @returns The response from the hotel chain query
 */
export const useHotelChainData = () => {
  const context = useContext(AppHotelChainDataContext);

  if (!context) {
    throw new Error('useHotelChainData must be used within a AppHotelChainDataProvider');
  }
  return context;
};

export default AppHotelChainDataProvider;
